import * as React from 'react';

import MenuContent from './MenuContent';
import Service from '../../util/Service';
import { useProfile } from '../common/useProfile';

export default function MenuComp(props) {
    const { darkMode, handleDarkMode, edit, nomePagina, style } = props;
    const prof = useProfile();
    const [pagina, setPagina] = React.useState();

    React.useEffect(() =>{   
        var sMenu = sessionStorage.getItem("menu");        
        if( sMenu){
            const jMenu = JSON.parse(sMenu);
            setPagina({
                menu: jMenu
            });
            return;
        }
        if( !nomePagina || nomePagina.length === 0 ) return;
        Service.GET('/api/paginaHtml/buscaPorNome/'+nomePagina).then(r => {
            if (r && r.length > 0) {
                setPagina(r[0]);
            }                        
        });
    }, [])

    if( !pagina) return;

    if( pagina.rules && prof.isOk){
        if( !prof.temAcesso(pagina.rules)) return;
    }

    return (
        <MenuContent 
            menuJson={ pagina.menu } darkMode={darkMode} 
        />
    )

}